var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.WhiteliRtroutes.includes(_vm.$route.path))?[_c('router-view')]:[_c('IndexComponent')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }